var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 85.853,
    rx: 6,
    fill: "#C76F31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2795_7565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9326 61.1447H64.068C64.5723 61.1447 64.9811 60.4168 64.9811 59.4412V41.7959C64.9811 41.252 64.7385 40.7363 64.3195 40.3894L43.665 23.2868C42.9893 22.7273 42.0113 22.7273 41.3357 23.2868L20.681 40.3894C20.262 40.7363 20.0195 41.252 20.0195 41.7959V59.4412C20.0195 60.6357 20.4283 61.1447 20.9326 61.1447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.999 60.3574L42.5005 42.4297L34.002 60.3574L42.5005 61.1477L50.999 60.3574Z",
    fill: "#1F2526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0016 60.3555L32.3566 61.1712L32.1807 61.9872H52.8196L52.6717 61.1964L50.9986 60.3555H34.0016Z",
    fill: "#05303D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1678 33.0661H44.2057V31.104C44.2057 30.7251 43.8985 30.418 43.5197 30.418H41.4807C41.1017 30.418 40.7946 30.7251 40.7946 31.104V33.0661H38.8325C38.4536 33.0661 38.1465 33.3733 38.1465 33.7521V35.7912C38.1465 36.1701 38.4537 36.4772 38.8325 36.4772H40.7946V38.4394C40.7946 38.8182 41.1018 39.1254 41.4807 39.1254H43.5197C43.8986 39.1254 44.2057 38.8182 44.2057 38.4394V36.4772H46.1678C46.5467 36.4772 46.8538 36.1701 46.8538 35.7912V33.7522C46.8539 33.3733 46.5467 33.0661 46.1678 33.0661Z",
    fill: "#DC5C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0686 60.8273H53.5514L52.3955 61.6431L52.8203 62.4589H64.0686C64.5728 62.4589 64.9816 62.0501 64.9816 61.5458V59.9141C64.9816 60.4185 64.5728 60.8273 64.0686 60.8273Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1808 62.4589L32.6056 61.6431L31.4497 60.8273H20.9326C20.4283 60.8272 20.0195 60.4184 20.0195 59.9141V61.5458C20.0195 62.05 20.4283 62.4589 20.9326 62.4589H32.1808Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4496 60.3559L33.4716 59.9801C38.7399 54.7787 41.6227 45.8728 42.4995 42.4297C37.8389 51.1799 31.0784 53.4506 29.1535 53.9352C28.8809 54.0038 28.7375 54.303 28.8524 54.5596L31.4496 60.3559Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4492 60.3574L32.1804 61.9891C40.5334 55.3924 42.4998 42.4297 42.4998 42.4297C42.4996 42.4301 42.4993 42.4307 42.499 42.4311C41.2934 46.2771 37.8949 55.2684 31.4492 60.3574Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5508 60.3559L51.5288 59.9801C46.2605 54.7787 43.3777 45.8728 42.501 42.4297C47.1615 51.1799 53.922 53.4506 55.847 53.9352C56.1196 54.0038 56.2631 54.303 56.1481 54.5596L53.5508 60.3559Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5506 60.3574L52.8195 61.9891C44.4665 55.3924 42.5 42.4297 42.5 42.4297C42.5003 42.4301 42.5005 42.4307 42.5008 42.4311C43.7064 46.2771 47.105 55.2684 53.5506 60.3574Z",
    fill: "#7B7B7B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 57.9015L20 41.4297V62.3938H65L33.5 85.8536H8.5C8.5 85.8536 4.87913 86.4112 3 85.3545C1.43149 84.4725 0 81.8605 0 81.8605V57.9015Z",
    fill: "#333333",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2795_7565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.9615,
    height: 44.9615,
    fill: "white",
    transform: "translate(20.0195 19.9453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampIcon);
export default __webpack_public_path__ + "static/media/camp_icon.dab4facedc16ffd8559dc21a004af815.svg";
export { ForwardRef as ReactComponent };